<template>
  <el-dialog @open="open" title="Selecionar Período" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" :modal-append-to-body="false" width="500px">
    <el-form ref="form" size="small" label-position="top" hide-required-asterisk	:show-message="false" style="padding:0;">

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="Data Inicial">
            <el-date-picker
              v-model="dataInicial"
              format="dd/MM/yyyy" 
              value-format="dd/MM/yyyy"
              v-mask="'##/##/####'">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Data Final">
            <el-date-picker
              v-model="dataFinal"
              format="dd/MM/yyyy" 
              value-format="dd/MM/yyyy"
              v-mask="'##/##/####'">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      
    </el-form>
    <span slot="footer">
      <el-button @click="gerarResumoFinanceiroContrato" type="primary" size="small" round class="btn-box-shadow">Selecionar</el-button>
    </span>
  </el-dialog>
</template>

<script>

import { mapActions } from "vuex";

export default {
  props: {
    aluguel: Object,
    visibility: Boolean
  },
  data() {
    return {
      dataInicial: undefined,
      dataFinal: undefined
    }
  },
  methods: {
    ...mapActions(["showLoading", "hideLoading"]),
    ...mapActions("alugueisContratosStore", [
      "gerarRelatorio",
      ]),

    open() {
      this.reset();
    },

    gerarResumoFinanceiroContrato() {
      let payload = { 
        nome: "RESUMO_FINANCEIRO_ALUGUEL",
        aluguel: { id: this.aluguel.id },
        dataInicial: this.dataInicial,
        dataFinal: this.dataFinal
      };

      this.showLoading();
      this.gerarRelatorio(payload)
      .then((response) => {
        this.hideLoading();
        switch(response.status) {
          case "SUCESSO":
            window.open(response.mensagem, '_blank');  
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível comunicar-se com o servidor");
      });
    },

    reset() {
      this.dataInicial = undefined;
      this.dataFinal = undefined;
    },

    fechar() {
      this.$emit('close');
    }, 
  }
}
</script>
